export enum EPlateAddressState {
    Unknown = -1,
    Normal = 0,
    Faulty,
  }
  